import styled from 'styled-components';

export const CategoryListStyled = styled.div`
  display: grid;
  grid-template-columns: 3fr max-content;
  row-gap: 10px;
  margin-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  column-gap: 20px;
`;

export const CategoryName = styled.p<{ selected: boolean }>`
  font-weight: ${(props) => (props.selected ? 'bold' : 'normal')};
`;
